import React, { useEffect, useState } from 'react'
import { REFRESH_OPTIONS } from '../core/consts'

type Props = {
  intervalMs: number
  setIntervalMs: (ms: number) => void
  lastUpdated: number | null
  onRefresh: () => void
}

const RefreshSelect: React.FC<Props> = ({ intervalMs, setIntervalMs, lastUpdated, onRefresh }) => {
  const [, forceTick] = useState(0)

  // Re-render the "updated N sec ago" label once per second.
  useEffect(() => {
    const id = setInterval(() => forceTick((n) => n + 1), 1000)
    return () => clearInterval(id)
  }, [])

  const agoSec = lastUpdated ? Math.max(0, Math.round((Date.now() - lastUpdated) / 1000)) : null
  const agoText =
    agoSec === null
      ? null
      : agoSec < 60
        ? `${agoSec} сек`
        : agoSec < 3600
          ? `${Math.floor(agoSec / 60)} мин`
          : `${Math.floor(agoSec / 3600)} ч`

  return (
    <div className='d-flex align-items-center gap-3'>
      {agoText !== null && <span className='text-gray-700 fs-8'>обновлено {agoText} назад</span>}
      <select
        className='form-select form-select-sm w-auto'
        value={intervalMs}
        onChange={(e) => setIntervalMs(Number(e.target.value))}
      >
        {REFRESH_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.value === 0 ? o.label : `Обновлять: ${o.label}`}
          </option>
        ))}
      </select>
      {intervalMs === 0 && (
        <button
          type='button'
          className='btn btn-sm btn-primary d-flex align-items-center'
          title='Обновить сейчас'
          onClick={onRefresh}
        >
          <i className='bi bi-arrow-repeat fs-5 me-1' />
          Обновить
        </button>
      )}
    </div>
  )
}

export default RefreshSelect
